<template>
<b-row>
    <b-colxx xxs="12">
      <b-toast id="my-toast" variant="warning" solid>
        <template #toast-title>
          <div class="d-flex flex-grow-1 align-items-baseline">
            <strong class="mr-auto">예약 연동정보 변경 안내</strong>
          </div>
        </template>
        <span>외부 예약 채널과 연동중인 정보가 변경되었습니다.</span><br/>
        <span @click="moveOnTop" style="cursor: pointer">변경 정보 확인하기 ></span>
      </b-toast>
      <div class="mb-2 top-alert" v-if="locationAlert && !locationAlertIgnore" style="background-color: #f3afaf" >
        <div style="display: block; ">
          <h5 class="font-weight-bold"><b-icon icon="info" class="mr-1"></b-icon>장소정보 변경 안내</h5>
          <span>외부 예약 채널과 연동중인 장소정보가 변경되었습니다.  변경사항을 외부 연동 채널에 반영하시겠습니까?</span>
        </div>
        <div class="pull-right" style="align-items: center; display: flex;">
          <h5 class="mb-0 mr-2" style="cursor: pointer" @click="updateKakaoSync('STORE',false)"><span class="badge badge-disabled">무시</span></h5>
          <h5 class="mb-0" style="cursor: pointer" @click="updateKakaoSync('STORE',true)"><span class="badge badge-danger">반영</span></h5>
<!--          <input type="button" class="margin-r-5 btn btn-dark" value="무시" @click="locationAlert=false;">-->
<!--          <input type="button" class="margin-r-5 btn btn-danger" value="반영" @click="updateKakaoSync('STORE')">-->
        </div>
      </div>
      <div class=" mb-2 top-alert" v-if="reserveAlert && !reserveAlertIgnore" style="background-color: #f3afaf" >
        <div style="display: block">
          <h5 class="font-weight-bold"><b-icon icon="info" class="mr-1"></b-icon>예약정보 변경 안내</h5>
          <span>외부 예약 채널과 연동중인 예약정보가 변경되었습니다.<br>추가 수정사항이 있는 경우 설정을 모두 마친 후 “반영” 버튼을 눌러주세요.</span>
          <label style="display: block; font-weight: bold">※ 반영하지 않는 경우 외부 채널과 예약 연동 시 오류가 발생됩니다. ※</label>

        </div>
        <div class="pull-right" style="align-items: center; display: flex;">
          <h5 class="mb-0 mr-2" style="cursor: pointer" @click="updateKakaoSync('RESERVATION',false)"><span class="badge badge-disabled">무시</span></h5>
          <h5 class="mb-0" style="cursor: pointer" @click="updateKakaoSync('RESERVATION',true)"><span class="badge badge-danger">반영</span></h5>

        </div>
      </div>
      <h1>{{ $t('menu.edit-shop') }}</h1>
      <piaf-breadcrumb />
<!--      <b-button variant="warning" @click="makeToast('warning')" class="mb-2">toast test</b-button>-->
        <b-tabs nav-class="separator-tabs ml-0 mb-5" content-class="tab-content" :no-fade="true">
            <b-tab title="기본 정보">
                <edit-basic-info @get-kakao-id="getKakaoId" @get-kakao-alert="getKakaoAlert" />
            </b-tab>
            <b-tab title="메뉴관리">
              <MenuAdminicular @get-kakao-alert="getKakaoAlert"/>
            </b-tab>
            <b-tab title="예약 기본 설정">
                <edit-booking-settings :kakao-id="kakaoId" />
            </b-tab>
            <!--        <b-tab title="주말 설정">-->
            <!--          <edit-weekend-settings />-->
            <!--        </b-tab>-->
            <b-tab title="예약 가능 인원 설정">
                <edit-booking-headcount-settings :kakao-id="kakaoId" @get-kakao-alert="getKakaoAlert" />
            </b-tab>
            <b-tab title="예약 관리">
                <ReservationManag  />
            </b-tab>
            <b-tab title="시간대 할인 설정">
                <TimeZoneDiscount />
            </b-tab>
            <b-tab title="프로모션">
                <Promotion />
            </b-tab>
            <b-tab title="매장 등록 정보">
                <edit-registration-info @get-kakao-alert="getKakaoAlert" />
            </b-tab>
            <b-tab title="전시관리" v-if="displayFalg">
              <Display />
            </b-tab>
        </b-tabs>
    </b-colxx>
</b-row>
</template>

<script>
import Promotion from '../../components/Pages/Promotion';
import TimeZoneDiscount from '../../components/Pages/TimeZoneDiscount';
import ReservationManag from '../../components/Pages/ReservationManag';
import MenuAdminicular from '../../components/Pages/MenuAdminicular';
import SingleLightbox from "../../components/Pages/SingleLightbox";
import GalleryDetail from "../../components/Pages/GalleryDetail"
import GalleryProfile from "../../components/Pages/GalleryProfile"
import UserFollow from "../../components/Cards/UserFollow";
import RecentPost from "../../components/Common/RecentPost";
import UserCardBasic from "../../components/Cards/UserCardBasic";
import Post from "../../components/Cards/Post";
import EditShopBasicInfo from "./edit/EditShopBasicInfo";
import EditShopRegistrationInfo from "./edit/EditShopRegistrationInfo";
import EditShopBookingSettings from "./edit/EditShopBookingSettings";
import EditShopWeekendSettings from "./edit/EditShopWeekendSettings";
import EditShopBookingHeadcountSettings from "./edit/EditShopBookingHeadcountSettings";

import produtcs from "../../data/products";
import recentPosts from "../../data/recentPosts";
import followers from "../../data/follow";
import posts from "../../data/posts";
import Display from '../../components/Pages/Display';
import {mapGetters} from "vuex";
import api from "@/constants/api";
import {reqGet} from "@/constants/request";
import {rescode} from "@/constants/common";
export default {
    components: {
        Display,
        Promotion,
        TimeZoneDiscount,
        ReservationManag,
        MenuAdminicular,
        "single-lightbox": SingleLightbox,
        "gallery-detail": GalleryDetail,
        "gallery-profile": GalleryProfile,
        "user-follow": UserFollow,
        "recent-post": RecentPost,
        "user-card-basic": UserCardBasic,
        "post": Post,
        "edit-basic-info": EditShopBasicInfo,
        "edit-registration-info": EditShopRegistrationInfo,
        "edit-booking-settings": EditShopBookingSettings,
        "edit-weekend-settings": EditShopWeekendSettings,
        "edit-booking-headcount-settings": EditShopBookingHeadcountSettings
    },
    data() {
        return {
            storeCode: this.$route.params.storeCode,
            produtcs: produtcs.slice(0, 15),
            recentPosts,
            followers: followers.slice(0, 5),
            friends: followers.slice(0),
            posts,
            displayFalg: false,
            kakaoId: 0,
            syncData:null,
            locationAlert:false,
            reserveAlert:false,
            kakaoAlert:false,
            reserveAlertIgnore:false,
            locationAlertIgnore:false,
        };
    },
    mounted() {
      this.userRole = this.currentUser.userRole.split('_')[0]
      this.getInfo();
      this.getKakaoId();

    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },
    methods: {
      requrlChange(brdapiName, strapiName, brdquerystring, strquerystring) {
        let reqURL = ''
        if (this.currentUser.userRole.split('_')[0] == "BRAND") {
          reqURL = api.changeAPI(this.siteName, api.basicURL + brdapiName) + brdquerystring
        } else {
          reqURL = api.changeAPI(this.siteName, api.basicURL + strapiName) + strquerystring
        }
        return reqURL
      },
      getInfo(){
        let reqURL = ''

        reqURL = api.changeAPI(this.$route.params.sitename, api.basicURL + api.alimtalkMng.getBrandInfo)

        const params =
          {"site_name": this.$route.params.sitename}

        this.$http.get(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          // ;
          if (res.data.code === "OK") {
            console.log(res.data.data.basicInfo)
            this.displayFalg = res.data.data.basicInfo.useSite

            // if(this.kakaoId){
            //   // window.scrollTo(0,0);
            //   this.getKakaoSync();
            // }
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);

        })

      },
      getKakaoId(val){
        this.kakaoId = val
        this.getKakaoSync()
      },
      moveOnTop(){
        window.scrollTo(0,0);
        this.getKakaoSync();
      },
      makeToast(variant = null) {
        this.$bvToast.show('my-toast')
      },
      async getKakaoSync(){
        await reqGet(
          this.requrlChange(api.shop.queryKakaoSyncBRD, api.shop.queryKakaoSyncSTR, "?storeCode=" + this.storeCode, "?storeCode=" + this.storeCode),
          this.currentUser.tokens.access.token,
          (result) => {
            if (result != null) {
              if (result.code == rescode.REQ_SUCCESS) {
                this.syncData = result.data;
                this.locationAlert = result.data.needSyncStore ?? false
                this.reserveAlert = result.data.needSyncReservation ?? false
                this.locationAlertIgnore = result.data.ignoreSyncStore
                this.reserveAlertIgnore = result.data.ignoreSyncReservation


              } else {
                alert(result.message);
              }
            }
          }
        );

      },
      updateKakaoSync(val,isSync){
        let params = {
          storeCode:this.storeCode,
          syncType:val,
          isSync:isSync
        }
        let reqURL = ''
        reqURL = this.requrlChange(api.shop.updateKakaoSyncBRD, api.shop.updateKakaoSyncStr, "?storeCode=" + this.storeCode,'')

        //
        this.$http.post(reqURL, params, {
          headers: {
            'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
          }
        }).then(res => {
          if (res.data.code === "OK") {
            if(val=='STORE'){
              this.locationAlert = false;
              this.locationAlertIgnore = true;
            }else{
              this.reserveAlert = false;
              this.reserveAlertIgnore = true;
            }

            this.$forceUpdate();

            alert('변경하였습니다.')
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      },
      getKakaoAlert(val){
        if(this.kakaoId){
          this.makeToast()
          this.getKakaoSync();
        }

        // if(val=='RESERVATION'){
        //   this.reserveAlert = true
        // }else if(val=='STORE'){
        //   this.locationAlert = true
        // }

      },
      showIgnore(val){
        // let tmpStorage = []
        // let tmpItem = localStorage.getItem('alertIgnore')
        // if(tmpItem){
        //   tmpStorage = JSON.parse(tmpItem)
        // }
        // // JSON.parse(JSON.stringify(b.priority));
        // let alertIgnore = {
        //   storeCode: this.storeCode,
        //   location: true,
        //   reservation: true,
        // }
        // if(val =="STORE"){
        //   alertIgnore.location = false;
        //   this.locationAlert = false;
        // }else if(val =="RESERVATION"){
        //   alertIgnore.reservation = false;
        //   this.reserveAlert = false;
        // }
        // let filteredArrIdx = tmpStorage.findIndex((item,idx) =>{
        //   return item.storeCode == this.storeCode
        // })
        // if(filteredArrIdx > -1){
        //   tmpStorage[filteredArrIdx] = alertIgnore
        // }else{
        //   tmpStorage.push(alertIgnore)
        // }
        // localStorage.setItem('alertIgnore',JSON.stringify(tmpStorage))
      },
      getIgnore(){
        // let tmpItem = localStorage.getItem('alertIgnore')
        //
        // if(tmpItem){
        //   let tmpArr = JSON.parse(tmpItem)
        //   for(let i = 0; i<tmpArr.length ; i++ ){
        //
        //     if(tmpArr[i].storeCode === this.storeCode){
        //
        //       this.locationAlert = tmpArr[i].location
        //       this.reserveAlert = tmpArr[i].reservation
        //       break;
        //     }
        //   }
        //
        //   this.$forceUpdate()
        // }
      }
    },
};
</script>
<style>
.width5{
  width: 5%;
}
.width7{
  width: 7%;
}
.width10{
  width: 10%;
}
.width15{
  width: 15%;
}
.width25{
  width: 25%;
}
.top-alert{
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 12px;
  border-radius: 4px;
}
</style>
